export type EventParams = {
  key: string;
  count?: number;
  sum?: number;
  dur?: number;
  segmentation?: Record<string, string>;
};

// oxlint-disable-next-line no-empty-function
export const trackEvent = (_eventParams: EventParams): void => {};
